'use client';

import { ReactNode } from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';

import i18next from 'i18next';

import config from '@app/next-i18next.config';

i18next.use(initReactI18next).init({
    ...config,
    lng: config.i18n.defaultLocale,
    ns: ['accommodation', 'checkout', 'common', 'home', 'social-media'],
});

export function I18nProvider({ children }: { children: ReactNode }) {
    return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
}
